import { render, staticRenderFns } from "./o4results.vue?vue&type=template&id=295f479b&scoped=true"
import script from "./o4results.vue?vue&type=script&lang=js"
export * from "./o4results.vue?vue&type=script&lang=js"
import style0 from "./o4results.vue?vue&type=style&index=0&id=295f479b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295f479b",
  null
  
)

export default component.exports